export default {
    name: 'ArticleListItem',

    props: {
        item: Object
    },

    computed: {
        isArticle() {
            if (this.item.is_category) {
                return 'true';
            } else {
                return 'false';
            }
        },

        itemURL() {
            if (this.$route.path.startsWith('/topic/')) {
                return this.item.is_category ? `/action/emergency-events/list-${this.item.id}` : `/topic/${this.item.slug}`;
            } else {
                return this.item.is_category ? `${this.$route.path}/list-${this.item.id}` : `/topic/${this.item.slug}`;
            }
        },

        isActive() {
            return this.$route.path === this.itemURL ? 'active' : '';
        }
    }
};